import { React, useState, useMemo, useEffect, useContext } from 'react'
import axios from 'axios'
import { useQuery } from '@apollo/client'
import { useSearchParams, Routes, Route, useParams, Link, useLocation, matchPath } from 'react-router-dom';
import xls from '../../../images/download-file-icon.png'
import sorting from '../../../images/up-down-arrow.png'
import ExcelPopup from '../../ExcelPopup'
import moment from 'moment'
import CompanyLogo from '../../CompanyLogo';
import RandomLogo from '../../RandomLogo';
import CustomNavigation from '../../../Utils/CustomNavigation';
import { routeNames } from '../../../routeSegments';
import DataTable from '../../DataTables/DataTable';
import ExcelDownloader from "../../shared/ExcelDownloader";
import { exportExcel, invIncInvestorDetail } from "../../../Config/config";
import routePathSegments from "../../../routeSegments";
import { useCallback } from 'react';
import useModule from '../../../hooks/useModule';
import Constants from '../../../Constants';
import { UserContext } from '../../../Contexts/UserContext';


const InvestorAngelPortfolioCompanies = (props) => {
    const [showXlDownload, setshowXlDownload] = useState(false);
    const location = useLocation();
    const isVcCompanyMatch = matchPath({ path: `${routePathSegments.vc}/*` }, location?.state?.prevPath ?? "")
    const { investorId } = useParams();
    const {primaryMasterId} = useModule();
    const {isStudent, isDirectoryUser ,isTrialExport} = useContext(UserContext);

   /* The `customStringSortMemo` constant is a memoized function that is used for sorting string values
   in a DataTable component. */
    const customStringSortMemo = useMemo(() => {
        return (rowA, rowB, columnId, desc) => {
            const defaultVal = desc ? 'A' : 'Z';
            return (rowA?.values[columnId]?.name ?? defaultVal).localeCompare(rowB?.values[columnId]?.name ?? defaultVal);
        }
    }, []);

   /* The `dealDateSort` constant is a memoized function that is used for sorting the "Deal Date"
   column in the DataTable component. */
    const dealDateSort = useMemo(() => {
        return (rowA, rowB, columnId, desc) => {
            return moment.utc(rowA?.values[columnId].date).diff(moment.utc(rowB?.values[columnId].date))
        }
    }, [])

    console.log("props87", props);

   /* The `columns` constant is an array of objects that define the columns for the DataTable
   component. Each object represents a column and has properties such as `id`, `Header`, `accessor`,
   `className`, `Cell`, and `sortType`. */
    const columns = useMemo(() => [
        {
            id: "companyName",
            Header: "Company Name",
            accessor: "companyName",
            className:"w-[16%]",
            Cell: ({ value }) => {
                return <div className='flex items-center'>
                    {/* <CompanyLogo id={value?.id} /> */}
                    {value?.icon_path == "default.png" || value?.icon_path == "/default.png" || !value?.icon_path ?
                        <RandomLogo name={value.name} page="company page" />
                        :
                        <CompanyLogo name={value.name} page="company page" logo={value?.icon_path} />
                    }
                    <Link className='hover:text-[#BC8B20] '
                        state={{ cameFrom: location.state?.prevPath }}
                        to={isVcCompanyMatch != null ? routeNames.vcCompanyFundById(value?.id, ) 
                        : routeNames.peCompanyFundById(value?.id, )}>
                        {value.name ?? "--"}
                    </Link>
                </div>
            },
            sortType: customStringSortMemo,
        },
        {
            id: "dealDate",
            Header: "Deal Date",
            accessor: "dealDate",
            className:"w-[14%]",
            Cell: (cell) => {
                const date = cell.value?.date ? moment(cell.value.date).format('MMM YYYY') : ""; // Check if date is not null

                return <Link state={{ cameFrom: location.state?.prevPath ?? "" }} to={isVcCompanyMatch != null ? routeNames.vcCompanyInvestmentDealById(cell.value?.id, cell.value?.dealId) : routeNames.peCompanyInvestmentDealById(cell.value?.id, cell.value?.dealId)}>
                    {date}
                </Link>
            },
            sortType: dealDateSort
        },
        {
            Header: "VC Funded",
            accessor: "vcfunded",
            className:"pr-2 w-[15%]",
            
           
        },
        {
            Header: "Multiple Angel Rounds",
            accessor: "angelFunded",
            className:"pr-2 w-[12%]"
           
        },
        {
            Header: "Exit Status",
            accessor: "status",
            className:"w-[2%]"
           
        }
    ], [customStringSortMemo, location.state?.prevPath]);

   /* The `rowData` constant is using the `useMemo` hook to memoize the data for the DataTable
   component. It iterates over the `props.investmentsData` array and creates a new array of objects,
   where each object represents a row in the DataTable. Each object has properties such as
   `companyName`, `dealDate`, `status`, `angelFunded`, and `vcfunded`, which are derived from the
   corresponding properties in the `props.investmentsData` array. */
    const rowData = useMemo(() => {
        const rows = [];

        props.investmentsData?.forEach(company => {
            rows.push({
                companyName: { name: company?.company_name, dealId: company?.angel_id, id: company?.company_id, icon_path: company?.icon_path },
                dealDate: { date: company?.angel_date, dealId: company?.angel_id, id: company?.company_id },
                status: company?.exit_status,
                angelFunded: company?.multiple_angel,
                vcfunded: company?.vc_fund,
            })
        });
        setshowXlDownload(rows.length !== 0)

        return rows;
    }, [props.investmentsData])

    /* The `initialSort` constant is using the `useMemo` hook to memoize an array of sorting options
    for the DataTable component. */
    const initialSort = useMemo(() => [
        {
            id: "dealDate",
            desc: true
        }
    ], []);


    return (
        <>
            <div className="space-y-6 pt-4 px-4 bg-[#EDEDED]">
                <div className=" bg-white rounded-lg shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
                    <div className="pt-4 px-5 border-b border-b-[#F1F1F1] ">
                        <div className="flex justify-between mb-2">
                            <p className=" text-[14pt] leading-[19pt] text-[#333333] lg:text-[17px] font-semibold  mb-2 lg:leading-[22px]">Portfolio Companies - Investments</p>
                            {isStudent =='false' && isTrialExport !='false' && showXlDownload && <ExcelDownloader
                                url={exportExcel}
                                fileName={Constants.exportNames.portfolio_companies_investments(props.investorName)}
                                data={{
                                    "type": primaryMasterId,
                                    "export_from": "detail",
                                    "module_type": "investors",
                                    "category": "angel",
                                    "section": "company_investments",
                                    "investor_id": [investorId]
                                }} />}
                        </div>
                    </div>

                    <div className="space-y-6">
                        <div className="bg-white pb-2 rounded-[6px]">
                            <DataTable columns={columns} data={rowData} sortBy={initialSort} />

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default InvestorAngelPortfolioCompanies